import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router' // Router,
import { Injectable } from '@angular/core'
import { CurrentUserGateway } from '../common/gateways/current-user-gateway'
import { CurrentUser } from '../common/models/current-user'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class IsSuperAdminOrGuruAdminGuard  {
    currentUser: Observable<CurrentUser>
    constructor(private currentUsergateway: CurrentUserGateway) {
        this.currentUser = this.currentUsergateway.getCurrentUser()
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUser.pipe(map((user) => user.IsSuperAdminAdmin || user.IsGuruAdmin || user.IsSuperAdminSMA || user.IsSuperAdminSMM))
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUser.pipe(map((user) => user.IsSuperAdminAdmin || user.IsGuruAdmin || user.IsSuperAdminSMA || user.IsSuperAdminSMM))
    }
}
